import React, {useState} from 'react';
import moment from 'moment-timezone';
import {useMutation} from '@apollo/client';
import {styled} from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import {Button, Typography, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import Grid from '@mui/material/Grid';

import {FORCE_CANCEL_BOOKING} from '../../queries/GraphQLQueries';
import {DATE_FORMAT_IN_COMPACT_READABLE_FORMAT} from "../../config/DateTimeConstants";

export default function CancelBookingDialog({booking, setAlertMessage}) {

    const gridItemStyle = {display: 'flex', mb: '1rem'};
    const gridContainerStyle = {backgroundColor: 'white', maxWidth: '30rem', direction: 'column'};
    const CloseButton = styled(IconButton)(() => ({
        position: 'absolute',
        right: 20,
        top: 12,
        color: (theme) => theme.palette.grey[500]
    }));

    const [forceCancelBooking] = useMutation(FORCE_CANCEL_BOOKING, {refetchQueries: ['GetFilteredBookings', 'GetParentAndChildrenInfo']});

    const [openDialog, setOpenDialog] = useState(false);

    const handleCancelButtonClick = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    const handleCancelBooking = () => {
        setAlertMessage({children: 'Cancelling booking...', severity: 'info'});

        forceCancelBooking({
            variables: {bookingId: booking.id}
        }).then(() => {
            setAlertMessage({children: 'Booking cancelled.', severity: 'success'});
            setOpenDialog(false);
        }).catch(error => {
            setAlertMessage({children: error?.message, severity: 'error'});
            console.log('error ' + error)
        });
    };

    return <>
        <Button variant='contained' size='small' onClick={handleCancelButtonClick}>Cancel</Button>
        <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle sx={{fontWeight: 'bold'}}>Cancel Member Booking?</DialogTitle>
            <CloseButton aria-label='close' onClick={handleCloseDialog}><CloseIcon/></CloseButton>
            <DialogContent>
                <Grid container sx={gridContainerStyle}>
                    <Grid sx={gridItemStyle}>
                        <Typography mt={-2}>
                            Are you sure you want to proceed?
                        </Typography>
                    </Grid>
                    <Grid container sx={{...gridItemStyle, ml: -1}} spacing={1}>
                        <Grid size={6}>
                            <Typography fontWeight={"bold"}>Service Type:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography>{booking.serviceType}</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography fontWeight={"bold"}>Performer:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography>{booking.performer}</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography fontWeight={"bold"}>Lesson Time:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography>{moment(booking.timeslot).format(DATE_FORMAT_IN_COMPACT_READABLE_FORMAT)}</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography fontWeight={"bold"}>Child Name:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography className="text-ellipsis">{booking.displayName}</Typography>
                        </Grid>
                    </Grid>
                    
                    <Button onClick={handleCancelBooking} variant='contained' sx={{ml: '20rem'}}>Cancel Booking</Button>
                </Grid>
            </DialogContent>
        </Dialog>
    </>;
}
